"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentReportNotFound = void 0;
const client_library_1 = require("@seneca/client-library");
class StudentReportNotFound extends client_library_1.ExtendableError {
    constructor(childId, reportId) {
        super(`No report found for child with id ${childId} and report id ${reportId}`);
    }
}
exports.StudentReportNotFound = StudentReportNotFound;
//# sourceMappingURL=StudentReportNotFound.js.map